module.exports = __webpack_public_path__ + "static/img/bg-card-blue.49c63f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/game/bg-card-blue.jpg
// module id = 740
// module chunks = 2 3 4 5 12